module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/nav//battle.png?v=cb94f253";